import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

export enum ID_PLACE_DEATH {
  CASA = 'nella casa posta',
  ALTRO = 'altro',
}

const list = Object.freeze([
  {
    id: ID_PLACE_DEATH.CASA,
    value: 'Nella casa posta in',
  },
  {
    id: ID_PLACE_DEATH.ALTRO,
    value: 'Altro',
  },
]);

interface ListPlaceDeathProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  isSmallSize?: boolean;
  label?: string;
}

const ListPlaceDeathComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
  label = 'Luogo morte',
}: ListPlaceDeathProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="place-death-label">
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId="place-death-label"
        id="place-death"
        name="place-death"
        value={value}
        label={required ? `${label} *` : label}
        onChange={onChange}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListPlaceDeathComponent.displayName = 'List Place Death component';

const ListPlaceDeath = memo(ListPlaceDeathComponent);

export default ListPlaceDeath as typeof ListPlaceDeathComponent;
